import axios from 'axios';
import getLanguage from '../utils/getLanguage';

const api = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL_AXIOS || 'https://ondivan-staging.herokuapp.com',
  // baseURL: 'https://ondivan-staging.herokuapp.com',
  headers: {
    Authorization: '',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('user-token');
    const language = getLanguage(window.location.href);

    if (token) {
      // eslint-disable-next-line no-param-reassign
      config.headers.Authorization = `Token ${token}`;
    }

    // eslint-disable-next-line no-param-reassign
    config.headers.language = language;
    return config;
  },
  (error) => Promise.reject(error),
);

export default api;
